import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ChartInfoDrawer.css';

/**
 * Expandable bottom drawer for chart metadata
 * @param {Object} props - Component props
 * @param {Object} props.metadata - Chart metadata (time_period, granularity, data_sources)
 * @param {string} props.dataType - Data type (categorical, financial, etc.)
 * @param {boolean} props.defaultOpen - Whether drawer is open by default
 * @returns {JSX.Element} Chart info drawer component
 */
const ChartInfoDrawer = ({ metadata, dataType, defaultOpen = false }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`chart-info-drawer ${isOpen ? 'open' : 'closed'}`}>
      <div className="drawer-header">
        <h4 className="drawer-title">{t('charts.chartInfo.metadata')}</h4>
        <button className="drawer-toggle" onClick={toggleDrawer} aria-label={isOpen ? 'Collapse' : 'Expand'}>
          {isOpen ? '▼' : '▲'}
        </button>
      </div>

      <div className="drawer-content">
        <div className="metadata-content">
          {metadata?.time_period && (
            <div className="metadata-row">
              <span className="metadata-label">{t('charts.period')}</span>
              <span className="metadata-value">
                {metadata.time_period.start_date} {t('charts.to')} {metadata.time_period.end_date}
              </span>
            </div>
          )}
          {metadata?.granularity && (
            <div className="metadata-row">
              <span className="metadata-label">{t('charts.granularity')}</span>
              <span className="metadata-value">{metadata.granularity}</span>
            </div>
          )}
          {dataType && (
            <div className="metadata-row">
              <span className="metadata-label">{t('charts.dataType')}</span>
              <span className="metadata-value">{dataType}</span>
            </div>
          )}
          {metadata?.data_sources && metadata.data_sources.length > 0 && (
            <div className="metadata-row">
              <span className="metadata-label">{t('charts.sources')}</span>
              <span className="metadata-value">{metadata.data_sources.join(', ')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChartInfoDrawer;

